import CardTermsConditions from './CardTermsConditions';

export default CardTermsConditions;
